import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileSelectorService, SimpleObject } from './profile-selector.service';
import { AuthService } from 'libs/auth/src/lib/auth.service';
import { Router } from '@angular/router';
import { DxDropDownButtonModule } from 'devextreme-angular';
import { Subject, takeUntil } from 'rxjs';
import { ChangeDetectorRef, NgZone } from '@angular/core';

@Component({
  selector: 'dk-profile-selector',
  standalone: true,
  imports: [CommonModule, DxDropDownButtonModule],
  templateUrl: './profile-selector.component.html',
  styleUrls: ['./profile-selector.component.scss'],
})
export class ProfileSelectorComponent implements OnInit, OnDestroy {

  profileSettings: SimpleObject[] = [];
  userName = '';
  isOpened = false;
  renderDropdown = true;

  private destroy$ = new Subject<void>();

  constructor(
    public profileService: ProfileSelectorService,
    private authService: AuthService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {}

  ngOnInit(): void {
    this.profileSettings = this.profileService.getProfileSettings();

    this.authService.user$
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        this.userName = user
          ? `${user.profile?.name ?? ''}`.trim()
          : '';
      });
  }

  /** Avatar için baş harfler ('Ahmet Yılmaz' → 'AY', 'admin' → 'AD'). */
  get basHarfler(): string {
    const parcalar = (this.userName || '').trim().split(/\s+/).filter(Boolean);
    if (!parcalar.length) return '';
    const harfler = parcalar.length > 1
      ? parcalar[0][0] + parcalar[parcalar.length - 1][0]
      : parcalar[0].slice(0, 2);
    return harfler.toLocaleUpperCase('tr');
  }

  /** CSS content için tırnaklı baş harfler. */
  get harfCss(): string {
    return `"${this.basHarfler}"`;
  }

  onItemClick(e: any): void {
    const name = e?.itemData?.name;

    if (e?.component) {
      e.component.close();
    }

    if (name === 'Çıkış Yap') {
      this.authService.logout();
      return;
    }

    if (name === 'Profilim') {
      this.ngZone.run(() => {
        // Zıplatma tekniği (Forced Re-render)
        this.renderDropdown = false;
        this.cdr.detectChanges();

        this.router.navigate(['main/hesabim']).then(() => {
          setTimeout(() => {
            this.renderDropdown = true;
            this.cdr.detectChanges();
          }, 50);
        });
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}



// import { Component, OnInit } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { ProfileSelectorService, SimpleObject } from './profile-selector.service';
// import { AuthService } from 'libs/auth/src/lib/auth.service';
// import { Router } from '@angular/router';
// import { DxDropDownButtonModule } from 'devextreme-angular';
//
// @Component({
//   selector: 'dk-profile-selector',
//   standalone: true,
//   imports: [CommonModule,DxDropDownButtonModule],
//   templateUrl: './profile-selector.component.html',
//   styleUrls: ['./profile-selector.component.scss'],
// })
// export class ProfileSelectorComponent implements OnInit {
//   profileSettings: SimpleObject[];
//   userName: string = '';
//   constructor(public profileService : ProfileSelectorService, private authService: AuthService,private router: Router){
//   }
//
//   ngOnInit(): void {
//
//     const userInfo = JSON.parse(localStorage.getItem('kullanici') || '{}');
//     this.profileSettings = this.profileService.getProfileSettings();
//     this.userName = (userInfo?.adi + " " + userInfo?.soyadi).trim();
//   }
//
//
//   onButtonClick(e:any) {
//   }
//
//
//   onItemClick(e: any) {
//     const item = e.itemData.name === 'Profilim' ? 'profile' : 'logout';
//     this.profileService.switchItem(item);
//     if(e.itemData.name==="Çıkış Yap"){
//       this.authService.startLogout();
//     }
//     else if(e.itemData.name==="Profilim"){
//       this.router.navigate(['main/hesabim']);
//     }
//   }
//
// }
